import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { nodeAtomFamily } from "./nodeAtomFamily";

export const isNodeSelectedAtomFamily = atomFamily((nodeId: string) => {
  const baseAtom = atom((get) => {
    const node = get(nodeAtomFamily(nodeId));
    return Boolean(node?.selected);
  });

  baseAtom.debugLabel = `isNodeSelectedAtomFamily(${nodeId})`;
  return baseAtom;
});
